import {Directive, ElementRef, Input, OnInit} from '@angular/core';

@Directive({selector: '[sxTextEllipse]', standalone: false})
export class TextEllipseDirective implements OnInit {
  @Input() sxTextEllipse: string;

  constructor(private el: ElementRef) {
  }

  ngOnInit() {
    if (this.sxTextEllipse === 'strict') {
      // Multi-line ellipsis with line-clamp (2 lines)
      this.el.nativeElement.style.display = '-webkit-box'
      this.el.nativeElement.style.webkitLineClamp = '2'
      this.el.nativeElement.style.webkitBoxOrient = 'vertical'
      this.el.nativeElement.style.overflow = 'hidden'
      this.el.nativeElement.style.textOverflow = 'ellipsis'
      this.el.nativeElement.style.wordBreak = 'break-word'
    } else {
      // Default single-line ellipsis
      this.el.nativeElement.style.overflow = 'hidden'
      this.el.nativeElement.style.whiteSpace = 'nowrap'
      this.el.nativeElement.style.textOverflow = 'ellipsis'
    }
  }


}
